import {FC, useEffect, useRef} from 'react'

const MatrixRain: FC<{height?: number}> = ({height = 220}) => {
  const ref = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const canvas = ref.current
    if (!canvas) return
    const ctx = canvas.getContext('2d')
    if (!ctx) return
    canvas.width = canvas.offsetWidth
    canvas.height = height
    const fontSize = 14
    const columns = Math.floor(canvas.width / fontSize)
    const drops = new Array(columns).fill(1)
    const chars = '0123456789ABCDEF'

    const interval = setInterval(() => {
      ctx.fillStyle = 'rgba(0,0,0,0.08)'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.fillStyle = '#3699FF'
      ctx.font = `${fontSize}px monospace`
      drops.forEach((y, i) => {
        const text = chars[Math.floor(Math.random() * chars.length)]
        ctx.fillText(text, i * fontSize, y * fontSize)
        if (y * fontSize > canvas.height && Math.random() > 0.975) drops[i] = 0
        drops[i]++
      })
    }, 50)

    return () => clearInterval(interval)
  }, [height])

  return <canvas ref={ref} style={{width: '100%', height, background: '#1e1e2d'}} />
}

export default MatrixRain
